/**
* Dropdown Menu Component
* Files :
* - scripts/components/responsive-menu.js
* Dependencies :
* - Foundation 6 `DropDownMenu`
*/

import $ from 'jquery';
import { DropdownMenu } from 'foundation-sites';

window.addEventListener('load', function(event) {

  // ### Dropdown Menu
  // Settings
  const $dropDownMenuEl = $(".js-dropdown-nav > ul");
  const dropDownMenuOptions = {
    closingTime: 100,
  };
  // Init
  const dropDownMenuInstance = new DropdownMenu( $dropDownMenuEl, dropDownMenuOptions);
});
